import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { wrapWithContext } from './_';
const NotificationsContext = React.createContext({
    'notifications': [],
    'notify': (_) => { return () => { }; },
});
// export const CNotification = defineComponent<{ notification:Notification }>((props) => {
//   // TODO: x on right side for early removal
//   return () => {
//     return h('div',{
//       'class':`m-2 alert alert-${props.notification.kind === 'error' ? 'danger' : props.notification.kind}`,
//       'style':'position:sticky;top:0px;z-index:9999;',
//     },props.notification.message)
//   }
// },{
//   'props':['notification'],
// })
export const useNotifications = (channel) => {
    return React.useContext(NotificationsContext).notifications.filter((x) => channel === undefined || x.channel === channel).map((x) => {
        return {
            'render': () => React.createElement('div', {
                'key': x.id,
                'className': `m-2 alert alert-${x.kind === 'error' ? 'danger' : x.kind}`,
                'style': { 'position': 'sticky', 'top': '0px', 'zIndex': '1' },
            }, x.message),
        };
    });
};
export const useNotify = () => React.useContext(NotificationsContext).notify;
export const NotificationsProvider = (props) => {
    const [stateNotifications, setNotifications] = React.useState([]);
    /**
     * - when channel is `undefined`, it will display at the root level
     * - when timeout is `null`, the notification will persist indefinitely
     * @returns function that can be called to remove the notification
     */
    const notify = (x) => {
        const id = uuidv4();
        setNotifications((xs) => xs.concat([{
                'id': id,
                'channel': x.channel,
                'kind': x.kind,
                'message': x.message,
            }]));
        const remove = () => {
            setNotifications((xs) => xs.filter((x) => x.id !== id));
        };
        if (x.timeout !== null) {
            window.setTimeout(remove, (x.timeout || 3) * 1000);
        }
        return remove;
    };
    return wrapWithContext(NotificationsContext, { 'notifications': stateNotifications, 'notify': notify }, props.children);
};
